import { motion } from "framer-motion";

export default function Chapters({ content }) {
  const chapters = content.chapters || [];
  return (
    <section className="relative py-24 sm:py-32" data-testid="chapters-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }} className="font-mono text-xs tracking-[0.25em] uppercase text-sky mb-4">
          The Perez Osorio Standard
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-3xl">
          {content.about_heading}
        </motion.h2>
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.2 }} className="mt-6 max-w-2xl text-slate-400 leading-relaxed">
          {content.about_text}
        </motion.p>

        <div className="mt-16 space-y-0">
          {chapters.map((c, i) => (
            <motion.div key={c.num || i}
              initial={{ opacity: 0, y: 32 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="group grid md:grid-cols-12 gap-4 md:gap-8 items-start border-t border-white/10 py-10 hover:bg-white/[0.02] transition-colors duration-300 px-2 sm:px-4"
              data-testid={`chapter-${c.num || i}`}>
              <span className="md:col-span-3 font-display font-extrabold text-6xl lg:text-7xl text-stroke-blue group-hover:text-sky group-hover:[-webkit-text-stroke:0px] transition-all duration-500">
                {c.num}
              </span>
              <h3 className="md:col-span-4 font-display font-bold text-xl sm:text-2xl tracking-tight pt-2">{c.title}</h3>
              <p className="md:col-span-5 text-slate-400 leading-relaxed pt-2">{c.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
